'use client'

import { useState } from "react"

import { User } from "@/types/user"
import Button from "@/components/UiElements/Button";
import Modal from "@/components/Modal/Modal";
import ChangePasswordModal from "./ChangePasswordModal";

type UserActionsProps = {
    user: User
}

const UserActions = ({ user }: UserActionsProps) => {
    const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] = useState(false);

    if (!user) {
        return null;
    }

    return (
        <div>
            <div className="mt-md flex justify-start">
                <Button
                    size="md"
                    type="alt"
                    icon=""
                    iconClassName="font-icon-solid"
                    onClick={() => setIsChangePasswordModalOpen(true)}
                >
                    Change Password
                </Button>

            </div>

            <Modal
                isOpen={isChangePasswordModalOpen}
                onClose={() => setIsChangePasswordModalOpen(false)}
                title="Change Password"
                closeOnOutsideClick={false}
            >
                {isChangePasswordModalOpen && (
                    <ChangePasswordModal
                        user={user}
                        onClose={() => setIsChangePasswordModalOpen(false)}
                        onSuccess={() => {}}
                    />
                )}
            </Modal>
        </div>
    );
}

export default UserActions
